/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import thumbnailImg from 'assets/images/tumbnailImg.svg';
import CN from 'classnames';
import { Button, Input, SimpleSelect } from 'components/atoms';
import { Loader } from 'components/atoms/Loader';
import { Modal } from 'components/molecules/Modal';
import { saveAs } from 'file-saver';
import {
  useDeleteVRVideoByID,
  useGetAllVideos,
  useGetAllVideosForMontization,
  useUpdateVideoMonetizeStatus,
  useUpdateVideoStatus,
} from 'framework/api/methods';
import React, { FC, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDebounce from 'utils/debounce';

export interface VideosProps {
  [x: string]: any;
}

interface DownloadProgress {
  [videoId: string]: {
    progress: number;
    isDownloading: boolean;
    totalSize?: number;
    downloadedSize?: number;
  };
}

export const Videos: FC<VideosProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const statusParam = searchParams.get('status');

  const [selectedState, setSelectedState] = useState({
    label: statusParam === 'pending' ? 'Pending' : 'Approved',
    value: statusParam === 'pending' ? 'pending' : 'approved',
  });

  const [searchText, setSearchText] = useState('');
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false);
  const [isOpenDisapproveConfirmation, setIsOpenDisapproveConfirmation] = useState(false);
  const [isOpenApproveConfirmation, setIsOpenApproveConfirmation] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState('');

  const [videoList, setVideoList] = useState([]);
  const [downloadProgress, setDownloadProgress] = useState<DownloadProgress>({});

  const { mutate: getAllVideosMutate, isLoading: getAllVideosIsLoading } = useGetAllVideos();

  const { mutate: updateVideoStatusMutate, isLoading: updateVideoStatusIsLoading } =
    useUpdateVideoStatus();

  const { mutate: updateVideoMonetizeStatusMutate, isLoading: updateVideoMonetizeStatusIsLoading } =
    useUpdateVideoMonetizeStatus();

  const { mutate: deleteVRVideoByIDMutate, isLoading: deleteVRVideoByIDIsLoading } =
    useDeleteVRVideoByID();

  const getAllVideos = (status: string) => {
    getAllVideosMutate(
      {
        status,
        search: searchText === '' ? 'All' : searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setVideoList(successData.videos || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setVideoList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const queryClient = useQueryClient(); // ✅ returns an instance of QueryClient

  const updateVideoStatus = (vid: string, status: string) => {
    updateVideoStatusMutate(
      {
        vid,
        status,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          queryClient.invalidateQueries('notification-stats');
          notify(successData?.message || 'Status updated.', 'success');
          setIsOpenDisapproveConfirmation(false);
          setIsOpenApproveConfirmation(false);
          getAllVideos(selectedState.value);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const updateVideoMonetizeStatus = (vid: string, status: string) => {
    updateVideoMonetizeStatusMutate(
      {
        vid,
        status,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'Status updated.', 'success');
          getAllVideos(selectedState.value);
          // getAllMonatizeVideos(selectedState.value);
          setSelectedVideo('');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to delete video
  const deleteVRVideoByID = () => {
    deleteVRVideoByIDMutate(
      {
        vid: selectedVideo,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          getAllVideos(selectedState.value);
          setSelectedVideo('');
          setIsOpenDeleteConfirmation(false);
          notify(successData?.message || 'Video deleted successfully.', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    getAllVideos(selectedState.value);
  }, [debouncedSearchText]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins > 0 && secs > 0) {
      return `${mins.toString().padStart(2, '0')} min ${secs.toString().padStart(2, '0')} sec`;
    }
    if (mins > 0) {
      return `${mins.toString().padStart(2, '0')} min`;
    }
    return `${secs.toString().padStart(2, '0')} sec`;
  };

  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
  };

  // Enhanced download function with progress tracking
  const handleDownload = async (videoUrl: string, videoId: string, filename = 'video.mp4') => {
    try {
      // Initialize download progress
      setDownloadProgress((prev) => ({
        ...prev,
        [videoId]: {
          progress: 0,
          isDownloading: true,
          totalSize: 0,
          downloadedSize: 0,
        },
      }));

      // Check if browser supports fetch with streaming
      if (!window.fetch || !window.ReadableStream) {
        // Fallback to direct download for older browsers
        const link = document.createElement('a');
        link.href = videoUrl;
        link.download = filename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setDownloadProgress((prev) => ({
          ...prev,
          [videoId]: { ...prev[videoId], isDownloading: false },
        }));
        return;
      }

      const response = await fetch(videoUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const contentLength = response.headers.get('Content-Length');
      const totalSize = contentLength ? parseInt(contentLength, 10) : 0;

      // Update total size
      setDownloadProgress((prev) => ({
        ...prev,
        [videoId]: { ...prev[videoId], totalSize },
      }));

      const reader = response.body?.getReader();
      if (!reader) {
        throw new Error('ReadableStream not supported');
      }

      const chunks: Uint8Array[] = [];
      let downloadedSize = 0;

      while (true) {
        const { done, value } = await reader.read();

        if (done) break;

        chunks.push(value);
        downloadedSize += value.length;

        // Update progress
        const progress = totalSize > 0 ? Math.round((downloadedSize / totalSize) * 100) : 0;
        setDownloadProgress((prev: any) => ({
          ...prev,
          [videoId]: {
            ...prev[videoId],
            progress,
            downloadedSize,
          },
        }));
      }

      // Create blob and download
      const blob = new Blob(chunks);
      saveAs(blob, filename);

      // Complete download
      setDownloadProgress((prev) => ({
        ...prev,
        [videoId]: {
          ...prev[videoId],
          progress: 100,
          isDownloading: false,
        },
      }));

      notify('Download completed successfully!', 'success');

      // Clear progress after 3 seconds
      setTimeout(() => {
        setDownloadProgress((prev) => {
          const newProgress = { ...prev };
          delete newProgress[videoId];
          return newProgress;
        });
      }, 3000);
    } catch (error) {
      console.error('Download failed:', error);

      // Update progress to show error
      setDownloadProgress((prev) => ({
        ...prev,
        [videoId]: {
          ...prev[videoId],
          isDownloading: false,
          progress: 0,
        },
      }));

      // Fallback to opening in new tab
      notify('Download failed, opening video in new tab...', 'error');
      window.open(videoUrl, '_blank');

      // Clear progress after error
      setTimeout(() => {
        setDownloadProgress((prev) => {
          const newProgress = { ...prev };
          delete newProgress[videoId];
          return newProgress;
        });
      }, 2000);
    }
  };

  // Cancel download function
  const cancelDownload = (videoId: string) => {
    setDownloadProgress((prev) => {
      const newProgress = { ...prev };
      delete newProgress[videoId];
      return newProgress;
    });
  };

  return (
    <div className="flex flex-col w-full h-full py-6 px-8">
      <div className="flex justify-between items-center">
        <div className="w-1/3">
          <div className="w-[180px] bg-[#f7951e24]">
            <SimpleSelect
              isSearchable={false}
              value={selectedState}
              options={[
                {
                  label: 'Approved',
                  value: 'approved',
                },
                {
                  label: 'Pending',
                  value: 'pending',
                },
                {
                  label: 'Rejected',
                  value: 'rejected',
                },
                {
                  label: 'Deleted',
                  value: 'deleted',
                },
              ]}
              onChange={(e: any) => {
                setSelectedState(e);
                getAllVideos(e.value);
                setSearchParams({});
              }}
            />
          </div>
        </div>

        <div className="w-2/3 flex justify-start items-start">
          <Input
            icon="ri-search-line !text-[#C40D42] font-semibold"
            value={searchText}
            placeholder="Search here..."
            className="!w-[400px]"
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="h-full overflow-y-auto w-full mt-5">
        {(getAllVideosIsLoading || updateVideoStatusIsLoading) && (
          <Loader appearance="black" className="mt-5" />
        )}

        {!(getAllVideosIsLoading || updateVideoStatusIsLoading) && videoList?.length === 0 && (
          <div className="mt-5 text-sm text-center w-full text-neutral-500">No videos found.</div>
        )}
        {!(getAllVideosIsLoading || updateVideoStatusIsLoading) &&
          videoList?.map((video: any, index) => (
            <div className="p-3 flex bg-white rounded w-full h-fit mt-2" key={index}>
              <div className="flex h-[100px] gap-x-2 overflow-x-auto justify-between items-start w-full">
                <div className="flex w-1/3 gap-x-2 h-full">
                  <img
                    src={video?.cover_image_url}
                    alt="img-video"
                    className="h-[100px] w-[180px] object-cover rounded"
                  />

                  <div className="flex flex-col h-full w-fit justify-between items-start">
                    <div className="text-sm font-medium text-[#63717A] max-w-[400px] h-full max-h-[70px] overflow-y-auto">
                      {video?.title || ''}
                    </div>

                    <div className="flex gap-x-1 items-center">
                      <i className="ri-eye-fill text-[#d3a5b2] text-[20px] leading-6" />
                      <div className="text-[14px] leading-6 text-[#63717A]">
                        {video?.view_count || 0}
                      </div>
                      {video.video_url && (
                        <div className="pl-4 flex items-center gap-2">
                          {downloadProgress[video.vid]?.isDownloading ? (
                            <div className="flex items-center gap-2">
                              <div className="relative w-16 h-2 bg-gray-200 rounded-full overflow-hidden">
                                <div
                                  className="absolute top-0 left-0 h-full bg-[#C40D42] transition-all duration-300 ease-out"
                                  style={{
                                    width: `${downloadProgress[video.vid]?.progress || 0}%`,
                                  }}
                                />
                              </div>
                              <span className="text-xs text-[#63717A] min-w-[35px]">
                                {downloadProgress[video.vid]?.progress || 0}%
                              </span>
                              <i
                                className="ri-close-line text-[#C40D42] text-[16px] cursor-pointer hover:bg-red-100 rounded-full p-1"
                                onClick={() => cancelDownload(video.vid)}
                                title="Cancel download"
                              />
                            </div>
                          ) : (
                            <i
                              className="ri-download-2-line text-[#d3a5b2] text-[20px] leading-6 cursor-pointer hover:text-[#C40D42] transition-colors"
                              onClick={() => {
                                const filename = `${video.title || 'video'}_${video.vid}.mp4`;
                                handleDownload(video.video_url, video.vid, filename);
                              }}
                              title="Download video"
                            />
                          )}
                        </div>
                      )}
                    </div>

                    {/* Download progress info */}
                    {downloadProgress[video.vid]?.isDownloading && (
                      <div className="text-xs text-[#63717A] mt-1">
                        {downloadProgress[video.vid]?.totalSize &&
                        downloadProgress[video.vid]?.downloadedSize ? (
                          <span>
                            {formatFileSize(downloadProgress[video.vid]?.downloadedSize || 0)} /{' '}
                            {formatFileSize(downloadProgress[video.vid]?.totalSize || 0)}
                          </span>
                        ) : (
                          <span>Downloading...</span>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className={CN(
                    'bg-[#EFEFEF] flex flex-col p-3 gap-x-2 h-full rounded-md w-[calc(66%-160px)]',
                  )}
                >
                  <div className="flex w-full gap-x-3 flex-wrap gap-y-2">
                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Published</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-[145px] rounded text-[#63717A] !h-[24px]">
                        {video?.created_at
                          ? new Date(video.created_at)
                              .toLocaleString('en-US', {
                                month: 'short',
                                day: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                                timeZone: 'UTC',
                              })
                              .replace(',', '')
                          : ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Category</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.category || ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs">Length</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {formatTime(video.length_seconds) || ''}
                      </div>
                    </div>

                    {selectedState.value !== 'approved' && (
                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs min-w-[59px]">Monetize</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                          {video?.monetization_status === 0 ? 'Off' : 'On'}
                        </div>
                      </div>
                    )}

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[78px]">Uploaded By</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.uploaded_by || ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[50px]">Video Id</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.vid || ''}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-y-3 font-thin h-full justify-start items-start">
                  {(selectedState.value === 'pending' || selectedState.value === 'rejected') && (
                    <Button
                      bodyClassName="!justify-start !items-start"
                      className="!w-full !h-[38px] !bg-[#B3D335]"
                      onClick={() => {
                        setSelectedVideo(video.vid);
                        setIsOpenApproveConfirmation(true);
                      }}
                    >
                      <i className="ri-checkbox-circle-fill font-thin text-[16px] pr-1" />
                      Approve
                    </Button>
                  )}

                  {(selectedState.value === 'pending' || selectedState.value === 'approved') && (
                    <Button
                      bodyClassName="!justify-start !items-start"
                      className="!w-full !h-[38px] !bg-[#C40D42]"
                      onClick={() => {
                        setSelectedVideo(video.vid);
                        setIsOpenDisapproveConfirmation(true);
                      }}
                    >
                      <i className="ri-close-circle-fill font-thin text-[16px] pr-1" />
                      Disapprove
                    </Button>
                  )}

                  {selectedState.value === 'approved' && (
                    // add a toggle button
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-medium">Monetize</span>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={video?.monetization_status !== 0}
                          onChange={() => {
                            updateVideoMonetizeStatus(
                              video.vid,
                              video.monetization_status === 0 ? '1' : '0',
                            );
                          }}
                          className="sr-only peer"
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-[#C40D42] after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full" />
                      </label>
                    </div>
                  )}

                  {selectedState.value === 'deleted' && (
                    <Button
                      bodyClassName="!justify-start !items-start"
                      className="!w-full !h-[38px] !bg-[#C40D42]"
                      onClick={() => {
                        setSelectedVideo(video.vid);
                        setIsOpenDeleteConfirmation(true);
                      }}
                    >
                      <i className="ri-close-circle-fill font-thin text-[16px] pr-1" />
                      Delete
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>

      <Modal
        isActive={isOpenDeleteConfirmation}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="Yes"
        secondaryButtonTitle="No"
        secondaryButtonProps={{
          className: '!w-[100px]',
        }}
        primaryButtonProps={{
          className: '!w-[100px] !mr-2',
          isLoading: deleteVRVideoByIDIsLoading,
        }}
        onClickPrimaryBtn={() => {
          deleteVRVideoByID();
        }}
        onClickSecondaryBtn={() => {
          setIsOpenDeleteConfirmation(false);
          setSelectedVideo('');
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#C40D42]"
              onClick={() => {
                setIsOpenDeleteConfirmation(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#C40D42]" />
            <div className="pt-1 text-base text-[#737791] pb-3">
              Are you sure you want to delete this video?
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isActive={isOpenDisapproveConfirmation}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="Yes"
        secondaryButtonTitle="No"
        secondaryButtonProps={{
          className: '!w-[100px]',
        }}
        primaryButtonProps={{
          className: '!w-[100px] !mr-2',
          isLoading: updateVideoStatusIsLoading,
        }}
        onClickPrimaryBtn={() => {
          updateVideoStatus(selectedVideo, 'rejected');
        }}
        onClickSecondaryBtn={() => {
          setIsOpenDisapproveConfirmation(false);
          setSelectedVideo('');
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#C40D42]"
              onClick={() => {
                setIsOpenDisapproveConfirmation(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#C40D42]" />
            <div className="pt-1 text-base text-[#737791] pb-3">
              Are you sure you want to disapprove this video?
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isActive={isOpenApproveConfirmation}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="Yes"
        secondaryButtonTitle="No"
        secondaryButtonProps={{
          className: '!w-[100px]',
        }}
        primaryButtonProps={{
          className: '!w-[100px] !mr-2',
          isLoading: updateVideoStatusIsLoading,
        }}
        onClickPrimaryBtn={() => {
          updateVideoStatus(selectedVideo, 'approved');
        }}
        onClickSecondaryBtn={() => {
          setIsOpenApproveConfirmation(false);
          setSelectedVideo('');
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#C40D42]"
              onClick={() => {
                setIsOpenApproveConfirmation(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#C40D42]" />
            <div className="pt-1 text-base text-[#737791] pb-3">
              Are you sure you want to approve this video?
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Videos;
